export class Condition {

    constructor(chainOperator) {
        this.chainOperator = chainOperator;
    }


    field: ConditionField;
    chainOperator: string;
    operation: ConditionOperation;
    value: any = "";

}

export function getDefaultCondition(){
    return new Condition('and');
}

export class ConditionField {
    name: string;
    label: string;
    type: ConditionFieldType;
    list: Array<any>;
}

export enum ConditionFieldType {
    string = 0,
    number = 1,
    date = 2,
    bool = 3,
    list = 4
}

export class ConditionOperation {
    operator: string;
    supportedTypes: Array<ConditionFieldType>;
    input: boolean; // whether the operation requires an input control
}